var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field } from 'react-redux-form';
import { connect } from 'react-redux';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import { checkErrorsOnLabel } from "../utils/checkErrorsOnLabel";

import PropertyConfigOptions from "./PropertyConfigOptions";

export class FormConfigInput extends Component {
  render() {
    const { index, labelHasError, type, canBeFilter } = this.props;

    return (/*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: `form-group${labelHasError ? ' has-error' : ''}` }, void 0, /*#__PURE__*/
      _jsx("label", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Name")
      ), /*#__PURE__*/
      _jsx(Field, { model: `template.data.properties[${index}].label` }, void 0, /*#__PURE__*/
      _jsx("input", { className: "form-control" })
      )
      ),
      type === 'geolocation' && /*#__PURE__*/
      _jsx("div", { className: "geolocation-grouping-alert" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "info-circle" }), /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Adjacent geolocation properties will render on the same map"), "."
      )
      ), /*#__PURE__*/

      _jsx(PropertyConfigOptions, { index: index, type: type, canBeFilter: canBeFilter })
      ));

  }
}

FormConfigInput.defaultProps = {
  canBeFilter: true,
  labelHasError: false
};








export function mapStateToProps(state, props) {
  return {
    labelHasError: checkErrorsOnLabel(state, props)
  };
}

export default connect(mapStateToProps)(FormConfigInput);